import { defineComponent, h, watch } from 'vue';
import { Sections } from '@phi/components/layout';
import {
    hide_curvature_options_modal,
    showing_curvature_combs,
    showing_curvature_options_modal,
} from '../../state';
import { Dialog } from '@phi/components';
import { CurvatureCombScaling } from '../curvature-comb-scaling';
import { CurvatureCombCount } from '../curvature-comb-count';
import { toggle_edge_curvatures } from '@features/curvature-combs/actions';

export const CurvatureCombsOptionsModal = defineComponent({
    setup() {
        watch(() => showing_curvature_options_modal.value, (x) => {
            if (x) {
                if (showing_curvature_combs.value) {
                    toggle_edge_curvatures();
                    toggle_edge_curvatures();
                } else
                    toggle_edge_curvatures();
            }
        });

        return () => h(Dialog, {
            id: 'curvature-combs-options-modal',
            show: showing_curvature_options_modal.value,
            'onUpdate:show': x => showing_curvature_options_modal.value = x,
            onClose: hide_curvature_options_modal,
            confirm_label: null,
            title: 'Curvature combs options',
            backdrop: false,
        }, () => h(Sections, { separator: 'border', gap: 'wider' }, () => [
            h(CurvatureCombCount),
            h(CurvatureCombScaling),
        ]));
    },
});
